var headroom;

// Load background images
jQuery(".load-bg-img").each(function (i, obj) {
  var large_img = jQuery(this).attr("data-bg-large");
  var small_img = jQuery(this).attr("data-bg-small");

  var item = jQuery(this);

  var bgImg = new Image();
  bgImg.onload = function () {
    item.css("background-image", "url(" + bgImg.src + ")");
    item.addClass("loaded");
  };

  if (jQuery(document).width() > 800) {
    bgImg.src = item.attr("data-bg");
  } else if (jQuery(document).width() > 400) {
    bgImg.src = item.attr("data-bg-small");
  } else {
    bgImg.src = item.attr("data-bg-tiny");
  }
});

// Navigation
jQuery(".dropdown").on("show.bs.dropdown", function () {
  var elem = jQuery(this).find(".dropdown-menu");
  setTimeout(function () {
    elem.addClass("inplace");
  }, 100);
});
jQuery(".dropdown").on("hide.bs.dropdown", function () {
  jQuery(this).find(".dropdown-menu").removeClass("inplace");
});

// Back button for the main menu
jQuery("#menu-primary-nav .dropdown").on("hide.bs.dropdown", function () {
  jQuery(".subnavbar-toggler").removeClass("show");
  setTimeout(function () {
    jQuery(".subnavbar-toggler").removeClass("inplace");
  }, 200);
});
jQuery("#menu-primary-nav .dropdown").on("show.bs.dropdown", function () {
  jQuery(".subnavbar-toggler").addClass("inplace");
  setTimeout(function () {
    jQuery(".subnavbar-toggler").addClass("show");
  }, 200);
});
jQuery(document).ready(function () {
  jQuery(document).on("click", ".dropdown-menu", function (e) {
    e.stopPropagation();
  });
});

/*
 * Make footer dropdowns top level clickable
 */
jQuery(".footer a.dropdown-toggle").on("click", function () {
  if (jQuery(document).width() >= 768) {
    window.location.href = jQuery(this).attr("href");
  }
});

/*
 * Bio popups
 */
jQuery(document).ready(function () {
  jQuery(".modal-trigger").on("click", function () {
    var id = jQuery(this).attr("id");
    console.log(jQuery("#" + id + "-content .mtitle").html());
    //jQuery('#' + id + ' .mtitle').html();
    jQuery(".modal .modal-title").html(
      jQuery("#" + id + "-content .mtitle").html()
    );
    jQuery(".modal .modal-body").html(
      jQuery("#" + id + "-content .mbody").html()
    );

    jQuery(".modal").modal("show");
  });
});

jQuery(document).ready(function () {
  jQuery(".answer.collapse").on("hide.bs.collapse", function () {
    jQuery(this).parent().find("h3").removeClass("showing");
  });

  jQuery(".answer.collapse").on("show.bs.collapse	", function () {
    jQuery(this).parent().find("h3").addClass("showing");
  });

  jQuery(".nav.collapse").on("hide.bs.collapse", function () {
    jQuery(".navbar-container").removeClass("show");
    jQuery(".navbar-toggler").removeClass("show");
    jQuery("html").removeClass("show-nav");
    jQuery("body").removeClass("no-scroll");
    setTimeout(function () {
      jQuery(".navbar-container").removeClass("showing");
      jQuery(".navbar-toggler").removeClass("showing");
      jQuery("html").removeClass("showing-nav");
    }, 100);
  });

  jQuery(".nav.collapse").on("show.bs.collapse	", function () {
    jQuery(".navbar-container").addClass("showing");
    jQuery(".navbar-toggler").addClass("showing");
    jQuery("html").addClass("showing-nav");
    jQuery("body").addClass("no-scroll");

    setTimeout(function () {
      jQuery(".navbar-container").addClass("show");
      jQuery(".navbar-toggler").addClass("show");
      jQuery("html").addClass("show-nav");
    }, 100);
  });

  jQuery(".the-search-form.collapse").on("show.bs.collapse	", function () {
    setTimeout(function () {
      jQuery(".the-search-form input.search-field").focus();
      console.log("Here");
    }, 300);
  });
});

/*
 * Load the hero image
 */
var heroTween = new TimelineMax({ paused: true });
if (jQuery(".page-title").length) {
  var bgImg = new Image();
  bgImg.onload = function () {
    jQuery(".page-title").css("background-image", "url(" + bgImg.src + ")");

    setTimeout(function () {
      jQuery(".page-title").addClass("inplace");
    }, 20);

    setTimeout(function () {
      heroTween.play();
    }, 300);
  };

  if (jQuery(document).width() > 800) {
    bgImg.src = jQuery(".page-title").attr("data-bg");
  } else if (jQuery(document).width() > 400) {
    bgImg.src = jQuery(".page-title").attr("data-bg-small");
  } else {
    bgImg.src = jQuery(".page-title").attr("data-bg-tiny");
  }

  // Animate it for coolness
  jQuery(document).ready(function () {
    // Hero fade in
    var h1 = jQuery(".page-title h1, .page-title h2, .page-title h3, .page-title h4");
    var p = jQuery(".page-title p");
    var butt = jQuery(
      ".page-title .overlay a.butt, .page-title .flex-container a.butt, .page-title p a.butt"
    );

    heroTween
      .fromTo(
        h1,
        0.8,
        { opacity: 0, y: 10 },
        {
          opacity: 1,
          y: 0,
        },
        0,
        "0"
      )
      .fromTo(
        p,
        0.8,
        { opacity: 0, y: 10 },
        {
          opacity: 1,
          y: 0,
        },
        0.7,
        "-=.15"
      )
      .fromTo(
        butt,
        0.8,
        { opacity: 0, y: 10 },
        {
          opacity: 1,
          y: 0,
        },
        0.9,
        "-=.15"
      );
  });
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        var viewport_width = jQuery(document).width();
        var offset = 60;
        if (viewport_width < 1000) {
          offset = 60;
        }

        var myElement = document.querySelector("header");
        if (myElement) {
          // construct an instance of Headroom, passing the element
          headroom = new Headroom(myElement, {
            offset: offset,
            tolerance: {
              down: 11,
              up: 3,
            },
          });
          // initialise
          headroom.init();
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  jQuery(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

function getScrollTop() {
  if (typeof pageYOffset !== "undefined") {
    //most browsers except IE before #9
    return pageYOffset;
  } else {
    var B = document.body; //IE 'quirks'
    var D = document.documentElement; //IE with doctype
    D = D.clientHeight ? D : B;
    return D.scrollTop;
  }
}

function getHeaderTop(div) {
  var winTop;
  if (!div) {
    winTop = jQuery(window).scrollTop();
  } else {
    winTop = jQuery(div).offset().top;
  }
  var headerTop = winTop;
  if (headerTop > headerHidden) {
    headerTop = headerHidden;
  } else if (headerTop < 0) {
    headerTop = 0;
  }
  return headerTop;
}

// State of the header.
var top_stick = true;
var darker_nav = false;
var promo_in_place = false;

// Update the navigation based on the width of the viewport.
function updateNav() {
  //
  // Update header background color.
  //
  var from_top = jQuery(window).scrollTop();
  if (from_top > 10 && !darker_nav) {
    jQuery(".header").addClass("scrollnav");
    darker_nav = true;
  } else if (from_top <= 10 && darker_nav) {
    jQuery(".header").removeClass("scrollnav");
    darker_nav = false;
  }

  // Promo
  if (jQuery(".lp-promo").length > 0) {
    if (!promo_in_place && from_top > 200) {
      promo_in_place = true;
      jQuery(".lp-promo").addClass("inplace");
    } else if (promo_in_place && from_top <= 200) {
      promo_in_place = false;
      jQuery(".lp-promo").removeClass("inplace");
    }
  }
}

/*
 * Watch events
 */
jQuery(document).ready(function () {
  jQuery("html").addClass("js");
  //windowResizeTasks();

  updateNav();
  jQuery(window).scroll(jQuery.throttle(65, updateNav));
  jQuery(window).on("debouncedresize", function (event) {
    // Your event handler code goes here.
    updateNav();
  });

  // Marry widows
  setTimeout(function () {
    jQuery(".marry-widows h1, .marry-widows h2, .marry-widows h3").each(
      function () {
        var string = jQuery(this).html();
        string = string.replace(/ ([^ ]*)$/, "&nbsp;$1");
        jQuery(this).html(string);
      }
    );
  }, 100);
});

/*
 * Adjust some classes for facetwp
 */
jQuery(document).ready(function () {
  jQuery(document).on("facetwp-refresh", function () {
    jQuery(".facetwp-template").addClass("loading");
  });

  jQuery(document).on("facetwp-loaded", function () {
    jQuery(".facetwp-template").removeClass("loading");
  });
});

/*
 * Accordian
 */
jQuery(document).ready(function () {
  jQuery(".accordian.device-text").on("hidden.bs.collapse", function (e) {
    var id = e.target.id;

    console.log("Triggering hidden");

    // Hide others
    jQuery(".device-text .screenshot img").removeClass("show");
    jQuery(".device-text .screenrecording video").removeClass("show");

    console.log(id);
    jQuery("#" + id + "-dv").removeClass("show");
  });

  jQuery(".accordian.device-text").on("shown.bs.collapse", function (e) {
    var id = e.target.id;

    // Hide others
    jQuery(".device-text .screenshot img").removeClass("show");
    jQuery(".device-text.screenrecording video").removeClass("show");

    jQuery("#" + id + "-dv").addClass("show");

    // Scroll to on mobile
    if (jQuery(document).width() <= 768) {
      console.log("we here." + id);

      var offset = jQuery("#" + id).offset().top - 40;
      console.log("offset: " + offset);

      if (offset > 0) {
        jQuery("html, body").animate(
          {
            scrollTop: offset,
          },
          200
        );
      }
    }
  });

  device-ac29-2

  // the current open accordion will not be able to close itself
  jQuery('.accordion button[data-toggle="collapse"]').on("click", function (e) {
    if (!jQuery(this).hasClass("collapsed")) {
      e.stopPropagation();
    }
  });

  // Initialize any fancy dropdowns on tab switch.
  jQuery('.accordion button[data-toggle="collapse"]').on("click", function (e) {
    if (jQuery(".gfield_select").length > 0) {
      jQuery(".gfield_select").chosen({ no_results_text: "No results found" });
    }
  });

  // If we have some tabs on the page, check to see if we need to show a particular tab by default.
  if (jQuery(".tabbed-content").length > 0) {
    // Do we have a hash?
    if (window.location.hash) {
      var hash = window.location.hash;
      // Loop through all the tabbed content sections
      jQuery(".tabbed-content").each(function (i, obj) {
        var cards = jQuery(this).find(".card .collapse");
        //console.log(cards);
        cards.each(function (j, obj2) {
          if (hash == "#" + jQuery(this).attr("data-tb")) {
            jQuery(this).collapse("show");
          }
        });
      });
    }
  }
});

function updateTestimonialScroller() {
  if (jQuery(".testimonials-block").length > 0) {
    setTimeout(function () {
      var id = jQuery(".t-controls").attr("id");
      var leftPos = jQuery("#" + id + "-container").scrollLeft();

      // If we are all the way to left hide that arrow.
      if (leftPos <= 0) {
        jQuery(".t-controls a.back").addClass("out");
      } else {
        jQuery(".t-controls a.back").removeClass("out");
      }

      // Check if we're scrolled all the way to right?
      var viewable_width = jQuery(".testimonials-block .row").width();
      var scrollable_width = jQuery(".testimonials-block .row")[0].scrollWidth;
      //console.log("Scrollable width is " + scrollable_width);
      //console.log("Viewable width " + viewable_width);
      //console.log("Left position is  " + leftPos);

      if (leftPos + viewable_width + 100 >= scrollable_width) {
        jQuery(".t-controls a.forward").addClass("out");
      } else {
        jQuery(".t-controls a.forward").removeClass("out");
      }
    }, 210);
  }
}

/*
 * Testimonials side scroll block
 */
jQuery(document).ready(function () {
  updateTestimonialScroller();
  jQuery(".testimonials-block .container-fluid").scroll(
    jQuery.throttle(65, updateTestimonialScroller)
  );
  jQuery(".t-controls a.forward").click(function () {
    var id = jQuery(this).parent().attr("id");
    var leftPos = jQuery("#" + id + "-container").scrollLeft();

    jQuery("#" + id + "-container").animate({ scrollLeft: leftPos + 300 }, 200);

    updateTestimonialScroller();

    return false;
  });

  jQuery(".t-controls a.back").click(function () {
    var id = jQuery(this).parent().attr("id");
    var leftPos = jQuery("#" + id + "-container").scrollLeft();
    console.log(id);

    jQuery("#" + id + "-container").animate({ scrollLeft: leftPos - 300 }, 200);

    updateTestimonialScroller();

    return false;
  });
});

/*
 * Cookie notice
 */
jQuery(document).ready(function () {
  var allow_cookies = readCookie("allow_cookies");
  if (allow_cookies !== "yes") {
    jQuery(".cookie-notice").addClass("display");
    jQuery(".cookie-notice").addClass("inplace");
  } else {
    console.log("Cookies allowed.");
  }

  jQuery("#allow-cookies").click(function (event) {
    createCookie("allow_cookies", "yes", 7);

    setTimeout(function () {
      jQuery(".cookie-notice").removeClass("display");
    }, 200);
    jQuery(".cookie-notice").removeClass("inplace");

    return false;
  });
});

/*
 * Logo carousel
 */
jQuery(document).ready(function () {
  jQuery(".jcarousel").each(function (i, obj) {
    var jcarousel = jQuery(this);

    jcarousel
      .on("jcarousel:reload jcarousel:create", function () {
        var carousel = jQuery(this),
          width = carousel.innerWidth();

        // SHow 3 on desktop, not 4
        var ct_3 = false;
        if (jcarousel.find("ul").children("li").length == 3) {
          ct_3 = true;
        }

        if (width >= 600) {
          if (ct_3) {
            width = width / 3;
          } else {
            width = width / 4;
          }
        } else if (width >= 350) {
          width = width / 2;
        }

        carousel.jcarousel("items").css("width", Math.ceil(width) + "px");
      })
      .jcarousel({
        wrap: "circular",
      });

    jcarousel.jcarouselAutoscroll({
      interval: 2500,
    });
  });
});

/*
 * Pricing toggle
 */
jQuery(document).ready(function () {
  jQuery(".monthly-pricing-trigger").click(function () {
    // Hide annual pricing
    jQuery(".annual-pricing").removeClass("selected");
    // Deselect annual button
    jQuery(".pricing-toggle a").removeClass("selected");
    // Select monthly
    jQuery(".monthly-pricing").addClass("selected");
    // Select monthly button
    jQuery(".pricing-toggle .monthly-pricing-trigger").addClass("selected");
    return false;
  });

  jQuery(".annual-pricing-trigger").click(function () {
    // Hide monthly pricing
    jQuery(".monthly-pricing").removeClass("selected");
    // Deselect monthly button
    jQuery(".pricing-toggle a").removeClass("selected");
    // Select annual
    jQuery(".annual-pricing").addClass("selected");
    // Select annual button
    jQuery(".pricing-toggle .annual-pricing-trigger").addClass("selected");
    return false;
  });
});

/*
 * FAQ permalinks
 */
jQuery(document).ready(function () {
  if (window.location.hash) {
    var hash = window.location.hash;
    if (hash.search("faq-")) {
      // Close the header.
      setTimeout(function () {
        headroom.unpin();

        var pieces = hash.split("-");
        var id = pieces[1];

        // Show this faq.
        jQuery("#answer-" + id).collapse("toggle");
      }, 100);
    }
  }
});

// Allow user to pause the auto-play videos.
jQuery(document).ready(function () {
  jQuery(".pause-video a").on("click", function () {
    jQuery("video").each(function () {
      jQuery(this).get(0).pause();
    });
    return false;
  });
});

/**
 * Creates a cookie
 *
 * @param string The name of the cookie
 * @param string The value
 * @param int Life
 * @return
 */
function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

/**
 * Reads a cookie
 *
 * @param string The name of the cookie
 * @return The value, or null
 */
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
/**
 * Erase a cookie
 *
 * @param string The name of the cookie
 * @return
 */
function eraseCookie(name) {
  createCookie(name, "", -1);
}

var remove_this = false;
/*
 * VDXCOM-431
 */
function setHeaderURLs() {
  // Testing
  //jQuery('.top-navigation li.login').addClass('emphasize');
  //jQuery('.top-navigation li.login a').text('Launch VisualDx');
  //jQuery('.top-navigation li.buy').addClass('deemphasize');

  /*
  if (0) {
    jQuery('.content-for-nliv').css('display', 'none');
    jQuery('.content-for-liv').css('display', 'block');
  } else { 
    jQuery('.content-for-liv').css('display', 'none');
        jQuery('.content-for-nliv').css('display', 'block');
  }
  */

  jQuery.ajax({
    url: "/visualdx/api/auth/v1/check-cidr",
    dataType: "json",
    async: true,
    error: function (response) {
      jQuery(".content-for-liv").css("display", "none");
      jQuery(".content-for-nliv").css("display", "block");
    },
    success: function (response) {
      if (response.hasVDxVisitorRole === true) {
        // /purchase/subscriptions.jsf -> /logout?redirect=/purchase/subscriptions.jsf
        /*
        jQuery(".go-subscriptions").attr(
          "href",
          "/logout?redirect=/purchase/subscriptions.jsf"
        );
        */
        jQuery(
          'a[href="https://www.visualdx.com/purchase/subscriptions.jsf"]'
        ).attr("href", "/logout?redirect=/purchase/subscriptions.jsf");
        jQuery('a[href="/purchase/subscriptions.jsf"]').attr(
          "href",
          "/logout?redirect=/purchase/subscriptions.jsf"
        );

        // /account => /logout?redirect=/account
        //jQuery(".go-account").attr("href", "/logout?redirect=/account");
        // /visualdx/myVisualDx?usePassword -> /visualdx/logout?switchUser
        jQuery(
          'a[href="https://www.visualdx.com/visualdx/myVisualDx?usePassword"]'
        ).attr("href", "/visualdx/logout?switchUser");
        jQuery('a[href="/visualdx/myVisualDx?usePassword"]').attr(
          "href",
          "/visualdx/logout?switchUser"
        );

        // Hide all content for logged in users.
        jQuery(".content-for-liv").css("display", "none");
        jQuery(".content-for-nliv").css("display", "block");
      } else {
        if (response.hasCidrIp === true) {
          jQuery('a[href="/visualdx/myVisualDx?usePassword"]').attr(
            "href",
            "/visualdx"
          );

          jQuery(
            'a[href="https://www.visualdx.com/visualdx/myVisualDx?usePassword"]'
          ).attr("href", "/visualdx");
          // /visualdx/myVisualDx?usePassword -> /visualdx
          //jQuery(".launch-vdx").attr("href", "/visualdx");

          // Hide all content for logged in users.
          jQuery(".content-for-nliv").css("display", "none");
          jQuery(".content-for-liv").css("display", "block");
        }
        // Don't know if this ever happens, but we want to show something.
        else {
          // Hide all content for logged in users.
          jQuery(".content-for-liv").css("display", "none");
          jQuery(".content-for-nliv").css("display", "block");
        }
      }
    },
  });
}

/*
 * VDX link changes
 */
jQuery(document).ready(function () {
  // Delay this for just a moment
  setHeaderURLs(); // *** Uncomment and test before/after launch
});

// Fix bootstrap jump
function carouselNormalization(this_carousel) {
  var items = this_carousel.find(".carousel-item"), //jQuery('.carousel .carousel-item'), //grab all slides
    heights = [], //create empty array to store height values
    tallest; //create variable to make note of the tallest slide

  if (items.length) {
    function normalizeHeights() {
      items.each(function () {
        //add heights to array
        heights.push(jQuery(this).height());
      });
      tallest = Math.max.apply(null, heights); //cache largest value
      items.each(function () {
        jQuery(this).css("min-height", tallest + "px");
      });
    }
    normalizeHeights();

    jQuery(window).on("resize orientationchange", function () {
      (tallest = 0), (heights.length = 0); //reset vars
      items.each(function () {
        jQuery(this).css("min-height", "0"); //reset min-height
      });
      normalizeHeights(); //run it again
    });
  }
}
jQuery(document).ready(function () {
  jQuery(".carousel").each(function (i, obj) {
    carouselNormalization(jQuery(this));
  });
});

var hero_swiper;
jQuery(document).ready(function () {
  if (jQuery("#swiper_hero").length > 0) {
    const hero_swiper = new Swiper("#swiper_hero", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 0,
      //loop: true,
      centeredSlides: false,
      slidesPerView: 1,
      speed: 300,
      effect: "fade",

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      autoplay: true,

      autoplay: {
        delay: 5000,
      },

      on: {
        init: function () {
          // Load all the of the duplicate background images
          jQuery("#swiper_hero .swiper-slide-duplicate .load-bg-img").each(
            function () {
              loadBgImage(jQuery(this));
            }
          );

          // Remove all inplaces
          jQuery("#swiper_hero .swiper-slide").removeClass("inplace");

          // Load all the of the duplicate background images
          setTimeout(function () {
            jQuery("#swiper_hero .swiper-slide.swiper-slide-active").addClass(
              "inplace"
            );
          }, 200);

          var current_slide = this.realIndex;
          // Remove all active from the swiper title
          jQuery("#swiper_hero .swiper-title").removeClass("active");
          jQuery("#swiper_hero .swiper-title").each(function () {
            if (jQuery(this).attr("data-slide-index") == current_slide) {
              jQuery(this).addClass("active");
            }
          });

          var tmp_swiper = this;

          jQuery(".swiper-title").on("click", function () {
            var index = jQuery(this).attr("data-slide-index");
            tmp_swiper.slideTo(index, 100);
          });
        },

        slideChange: function () {
          // Remove all inplaces
          jQuery("#swiper_hero .swiper-slide").removeClass("inplace");

          // Load all the of the duplicate background images
          setTimeout(function () {
            jQuery("#swiper_hero .swiper-slide.swiper-slide-active").addClass(
              "inplace"
            );
          }, 200);

          var current_slide = this.realIndex;
          // Remove all active from the swiper title
          jQuery("#swiper_hero .swiper-title").removeClass("active");
          jQuery("#swiper_hero .swiper-title").each(function () {
            if (jQuery(this).attr("data-slide-index") == current_slide) {
              jQuery(this).addClass("active");
            }
          });
        },
      },
    });
  }
});

function loadBgImage(element) {
  var large_img = element.attr("data-bg-large");
  var small_img = element.attr("data-bg-small");

  var bgImg = new Image();
  bgImg.onload = function () {
    element.css("background-image", "url(" + bgImg.src + ")");
    element.addClass("loaded");
  };

  if (jQuery(document).width() > 800) {
    bgImg.src = element.attr("data-bg");
  } else if (jQuery(document).width() > 400) {
    bgImg.src = element.attr("data-bg-small");
  } else {
    bgImg.src = element.attr("data-bg-tiny");
  }
}

jQuery(document).ready(function () {
  const swiper = new Swiper("#swiper_posts_related", {
    // Optional parameters
    direction: "horizontal",
    spaceBetween: 10,
    loop: false,
    centeredSlides: false,

    // If we need pagination
    pagination: {
      el: "#swiper_posts_related .swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper_related_posts .swiper-button-next",
      prevEl: ".swiper_related_posts .swiper-button-prev",
    },

    breakpoints: {
      100: {
        slidesPerView: 1.1,
        spaceBetween: 5,
      },
      780: {
        slidesPerView: 1.1,
        spaceBetween: 5,
      },
      820: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      1300: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
    },
  });
});

// Mobile blog slider initialization
jQuery(document).ready(function () {
  const swiper = new Swiper(".mobile-swiper-container", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
